import { format } from "date-fns";

import { format as formatPhoneNumber, NumberFormat } from "libphonenumber-js";

import _ from "lodash";

export const formatDate = (
  value?: string,
  dateFormat: string = "MM/DD/YYYY"
): string | undefined =>
  !_.isNil(value) ? format(value, dateFormat) : undefined;

export const formatTime = (
  value?: string,
  timeFormat = "MM/DD/YYYY hh:mm:ss A"
): string | undefined =>
  !_.isNil(value) ? format(value, timeFormat) : undefined;

export const formatPhone = (
  value?: string,
  format = "NATIONAL"
): string | undefined =>
  !_.isNil(value)
    ? formatPhoneNumber(value, format as NumberFormat)
    : undefined;

export const formatCurrency = (value: string | number): string =>
  `$${_.toNumber(value).toFixed(2)}`;

export const na = (
  source: object,
  key: string,
  defaultValue: string = "N/A"
): any => _.get(source, key, defaultValue);
